import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Idea } from '../models/idea';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdeaService {
  constructor(
    private httpClient: HttpClient,
    @Inject('env') private env: any,
    private authService: AuthService
  ) {}

  public createIdea(idea: Idea) {
    idea.createdBy = this.authService.getCurrentEmail();

    const uri = `${this.env.apiUrlRoot}/Ideas`;
    return this.httpClient.post<{ id: string }>(uri, idea);
  }

  public attachFilesToIdea(id: string, files: File[]) {
    const uri = `${this.env.apiUrlRoot}/Ideas/${id}/attachments`;
    const formData = new FormData();
    files.forEach(file => {
      formData.append('attachment[data]', file);
    });
    return this.httpClient.post(uri, formData);
  }
}
